export default function Footer() {
  return (
    <footer>
      <div className="container">
        <div className="row">
          <div className="col">
            <p>
              &copy; 2023 Alex & Èric. All rights reserved.{" "}
            </p>
            <p className="social-icons">
              <a
                href="https://github.com/Alex-Eric"
                target="_blank"
                rel="noreferrer"
                >
                <i class="fab fa-github"></i>
              </a>
                  </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
